import Vue from 'vue';
import CustomPaginateLinks from '@/components/Global/CustomPaginateLinks';
import * as VuePaginate from 'vue-paginate';

Vue.use(VuePaginate);

/**
 * Global Mixin
 */
Vue.mixin({
	data() {
		return {
			paginateStepLinks: {
				next: 'Next',
				prev: 'Previous',
			},
			paginateClasses: {
				ul: 'pagination',
				'.left-arrow': 'page-item',
				'.right-arrow': 'page-item',
				'.number': 'page-item',
				a: 'page-link',
			},
		};
	},
});

Vue.component('custom-paginate-links', CustomPaginateLinks);
